<template>
  <div>
    <div class="container">
      <!--UPLOAD-->
      <form
        enctype="multipart/form-data"
        novalidate
        v-if="isInitial || isSaving"
      >
        <div class="dropbox">
          <input
            type="file"
            multiple
            :id="uploadFieldName"
            :name="uploadFieldName"
            :disabled="isSaving"
            @change="
              filesChange($event.target.name, $event.target.files);
              fileCount = $event.target.files.length;
            "
            accept=".pdf"
            class="input-file"
          />
          <p v-if="isInitial">
            {{ $t("fields.adjuntar") }}
          </p>
          <p v-if="isSaving">
            {{ $t("fields.cargando") }} <br />
            {{ nombre_archivo }}
          </p>
          <p v-if="isSuccess">
            {{ nombre_archivo }}
          </p>
        </div>
      </form>
      <div v-if="isSuccess">
        <div class="alert alert-success">
          <i class="icon-checkmark"></i> {{ $t("fields.adjunto_ok") }} :
          {{ nombre_archivo }}
        </div>
        <div class="btn-container">
          <button class="btn" type="button" @click="reset()">
            {{ $t("btn.cambiar") }}
          </button>
        </div>
      </div>
      <div v-if="isFailed">
        <div class="alert alert-warning">
          <i class="icon-warning"></i> Hubo un error al tratar de cargar el
          archivo : {{ nombre_archivo }}
        </div>
        <div class="btn-container">
          <button class="btn" type="button" @click="reset()">
            Volver a intentar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { upload } from './file-upload.service';

const STATUS_INITIAL = 0;
const STATUS_SAVING = 1;
const STATUS_SUCCESS = 2;
const STATUS_FAILED = 3;

export default {
  name: "adjunta-archivo",
  props: {
    required: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: "Texto"
    },
    model: {
      type: String,
      default: "archivo"
    },
    idTramiteDoc: {
      type: String,
      default: ""
    },
    maxSize: {
      type: Number,
      default: 45
    }
  },
  data () {
    return {
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: this.model,
      nombre_archivo: ""
    };
  },
  computed: {
    isInitial () {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving () {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed () {
      return this.currentStatus === STATUS_FAILED;
    }
  },
  methods: {
    reset () {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    save64 (urlBase64) {
      console.log('iniciando el registro');
      this.$service
        .post(`upload/${this.idTramiteDoc}`, {
          pdf: urlBase64.substring(28, urlBase64.length)
        })
        .then(response => {
          if (response.code === 1) {
            this.currentStatus = STATUS_SUCCESS;
          } else {
            this.$message.error(
              "Ocurrió un error al cargar el archivo, por favor inténtelo otra vez",
              response.message
            );
            this.currentStatus = STATUS_FAILED;
            this.reset();
          }
        })
        .catch(err => {
          this.uploadError = err.response;
          this.currentStatus = STATUS_FAILED;
        });
    },
    async filesChange (fieldName, fileList) {
      this.$loading.show("Subiendo archivo....");
      console.log("***********a:", fileList[0].size);
      console.log("***********b:", this.maxSize * 1024 * 1024);
      console.log(
        fileList[0].size > this.maxSize * 1024 * 1024
          ? "El archivo es muy grande️"
          : ""
      );
      let entrada = document.getElementById(this.model);
      let archivo = entrada.files[0];
      this.nombre_archivo = archivo.name;
      let fileExtention = this.nombre_archivo.split(".").pop();
      if (fileExtention !== 'pdf') {
        this.$loading.hide();
        this.$message.error('El archivo adjunto debe estar formato PDF obligatoriamente');
        return;
      }
      if (fileList[0].size > this.maxSize * 1024 * 1024) {
        this.$loading.hide();
        this.$message.error("El archivo es muy grande, por favor elija otro");
      } else {
        this.currentStatus = STATUS_SAVING;
        let entrada = document.getElementById(this.model);
        let archivo = entrada.files[0];
        this.nombre_archivo = archivo.name;
        if (!archivo) {
          this.$loading.hide();
          this.$message.error("Por favor seleccione un archivo");
          return;
        }
        let reader = new FileReader();
        reader.onloadend = await function (fileLoadedEvent) {
          let error = event.target.error;
          if (error != null) {
            this.$message.error(
              "El archivo no puede ser reconocido . Código de error: " +
                error.code
            );
          }
        };
        await reader.readAsDataURL(archivo);
        while (reader.readyState !== 2) {
          await this.sleep(1000);
        }
        this.save64(reader.result);
        this.$loading.hide();
      }
    },
    sleep (ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
  },
  mounted () {
    this.reset();
    // this.maxSize = 45;
  }
};
</script>

<style lang="scss">
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: #d8edfd;
  color: dimgray;
  padding: 10px 10px;
  min-height: 100px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/util/AdjuntaArchivo.vue